import { fluentProviderClassNames, useFluentProvider_unstable, } from '@fluentui/react-components';
import { useRef } from 'react';
import { mergeThemes } from '../util';
import { useGlobalTheme } from './useGlobalTheme';
var CLASS_NAME_REGEX = new RegExp("([^\\s]*".concat(fluentProviderClassNames.root, "\\w+)"));
// For use at root of non-react app to expose fluent theme css variables
// React apps should use OfficeFluentProvider
export function useThemeGenerator(theme) {
    var _a;
    var globalTheme = useGlobalTheme();
    var ref = useRef(null);
    // Would prefer to use useThemeStyleTag directly, but it is not exported
    var fluentState = useFluentProvider_unstable({ theme: mergeThemes(globalTheme, theme), targetDocument: document }, ref);
    // TODO: Relies on fluent class name format. Fluent team is discussing options for us.
    return (((_a = fluentState.themeClassName) === null || _a === void 0 ? void 0 : _a.split(' ').find(function (name) {
        return name.startsWith('fluent-provider') ||
            name.match(CLASS_NAME_REGEX);
    })) || '');
}
//# sourceMappingURL=useThemeGenerator.js.map